<template>
  <div
    class="section section-signup"
    :style="
      'background-image: url(' +
        myTheme.home_section_background_image +
        '); background-size: cover; background-position: top center; min-height: 700px;'
    "
    v-loading.fullscreen.lock="isLoading"
    element-loading-background="rgba(256, 256, 256, 0.6)"
  >
    <div class="dark-overlay"></div>
    <div class="container">
      <div class="row">
        <cards
          class="card-signup"
          style="margin-top:50px"
          header-classes="text-center"
          :style="{ color: myTheme.topMenu.normal.color }"
        >
          <template slot="header">
            <h3 class="card-title title-up">{{ $t('text.register') }}</h3>
          </template>
          <template>
            <ValidationProvider
              rules="required|email"
              ref="emailValidator"
              v-slot="{ errors }"
            >
              <fg-input
                class="no-border"
                type="email"
                inputClasses="white-input"
                v-model.lazy="postBody.email"
                placeholder="Enter Your Email"
                :error="errors[0]"
              ></fg-input>
            </ValidationProvider>
            <h6 class="card-title title-up">
              {{ $t('text.register_1') }}
            </h6>

            <ValidationProvider rules="required" v-slot="{ errors }">
              <fg-input
                type="text"
                inputClasses="white-input"
                class="no-border"
                v-model.lazy="postBody.first_name"
                :placeholder="$t('input.placeholder.first_name')"
                :error="errors[0]"
              ></fg-input>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <fg-input
                class="no-border"
                inputClasses="white-input"
                type="text"
                v-model.lazy="postBody.last_name"
                :error="errors[0]"
                :placeholder="$t('input.placeholder.last_name')"
              ></fg-input>
            </ValidationProvider>
            <h6
              class="card-title title-up"
            >
              {{ $t('text.register_2') }}
            </h6>

            <ValidationProvider
              rules="required|numeric"
              v-slot="{ errors }"
              ref="phoneValidator"
            >
              <fg-input
                class="no-border"
                type="tel"
                v-model="postBody.telephone_number"
                inputClasses="white-input"
                :error="errors[0]"
                :placeholder="$t('input.placeholder.mobile_number')"
              ></fg-input>
            </ValidationProvider>
            <h6
              class="card-title title-up"
            >
              {{ $t('text.register_3') }}
            </h6>
            <ValidationProvider
              ref="passwordValidator"
              rules="required|min:8|password:password_confirmation"
              v-slot="{ errors }"
            >
              <div class="input-group form-group center-align remove-margin-bottom" role="group">
                <fg-input
                  inputClasses="white-input"
                  class="no-border"
                  type="password"
                  ref="password"
                  id="password"
                  style="width:100%; padding-right: 1px;"
                  :error="errors[0]"
                  v-model.lazy="postBody.password"
                  :placeholder="$t('input.placeholder.create_password')"
                ></fg-input>
                <n-button
                  type="primary"
                  @click="switchVisability()"
                  round
                  icon
                  class="add-on-input icon-eye"
                  v-bind:style="myTheme.customizeButton"
                >
                  <span id="pass-status" class="fa fa-fw fa-eye"></span>
                </n-button>
              </div>
            </ValidationProvider>

            <ValidationProvider
              name="password_confirmation"
              ref="passwordConfirmationValidator"
              rules="required"
              v-slot="{ errors }"
            >
              <fg-input
                class="no-border"
                inputClasses="white-input"
                data-vv-name="password_confirmation"
                type="password"
                ref="password_confirmation"
                id="passwordConfirmation"
                :error="errors[0]"
                v-model.lazy="postBody.password_confirmation"
                :placeholder="$t('input.placeholder.confirm_password')"
              ></fg-input>
            </ValidationProvider>

            <!--------------- Start Agreement --------------->
            <div class="form-group input-group">
              <p>
                {{ $t('text.terms_conditions_1') }}
                <strong>
                  <a class="url-color clickable" @click="openModal()">
                    {{ $t('text.terms_conditions_2') }}
                  </a>
                </strong>
                {{ $t('text.terms_conditions_3') }}
              </p>
              <n-checkbox v-model="isAgree" style="width:100%"
                ><p :style="[isAgree === false ? {'color':'red !important'} : {'color':'#ffffff !important'}]" >{{ $t('text.agree') }}</p></n-checkbox>
            </div>
            <!--------------- End Agreement --------------->
            <!--------------- Start NewsLetter --------------->
            <div class="form-group input-group">
              <n-checkbox v-model="postBody.subscribed_to_newsletter">
                <p class="subscribe-newsletter">{{ $t('text.subscribe_our_newsletter') }}</p></n-checkbox>
            </div>
            <!--------------- End NewsLetter --------------->
          </template>
          <div class="card-footer text-center">
            <n-button
              class="btn-lg btn-round register-btn"
              v-bind:style="myTheme.customizeButton"
              :disabled="!isComplete"
              type="submit"
              id="form-submit"
              @click="register()"
              >{{ isComplete ? $t('button.let_s_go') : $t('button.complete_details') }}</n-button>
          </div>
          <div class="text-center">
            <n-button
              class="btn-lg btn-round register-btn"
              v-bind:style="myTheme.registrationButtons"
              @click="backToLogin()"
              >{{ $t('button.back_to_login') }}</n-button
            >
          </div>
        </cards>
      </div>
    </div>
    <!-- terms and conditions  -->
    <div class="modal-conditions">
      <modal
        :show.sync="shown"
        headerClasses="justify-content-center"
        class="modal-options"
        modalClasses="modal-dialog-centered modal-dialog-scrollable" >
        <h4 slot="header" class="title title-up">{{ $t('alebl.terms_and_conditions') }}</h4>
        <terms-and-conditions :hideBackButton="true"></terms-and-conditions>    
      </modal>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { FormGroupInput, Button, Cards, Checkbox, Modal } from "@/components";
import { ValidationProvider } from "vee-validate";
import router from "../router";
import "vue-loading-overlay/dist/vue-loading.css";
import { helpers } from "@/utilities";
import TermsAndConditions from './TermsAndConditions'
import onMesssageMixin from "@/mixins/onMesssageMixin";
export default {
  name: "register",
  mixins: [onMesssageMixin],
  bodyClass: "register-page",
  computed: {
    isComplete() {
      return (
        this.postBody.email &&
        this.postBody.first_name &&
        this.postBody.last_name &&
        this.postBody.password &&
        this.postBody.password_confirmation &&
        this.postBody.telephone_number &&
        this.isAgree
      );
    },
  },
  components: {
    [FormGroupInput.name]: FormGroupInput,
    [Button.name]: Button,
    ValidationProvider,
    Cards,
    [Checkbox.name]: Checkbox,
    Modal,
    TermsAndConditions
  },
  data() {
    return {
      getHelpers: helpers,
      postBody: {
        email: "",
        first_name: "",
        last_name: "",
        password: "",
        password_confirmation: "",
        telephone_number: "",
        accepted_terms_and_conditions : true, // set to true, since the user have to be Agree with the Terms to finish the registration
        accepted_privacy_policy : true, // set to true, since the user have to be Agree with the Terms to finish the registration
        subscribed_to_newsletter : false
      },
      showError: false,
      showSuccess: false,
      errors: [],
      isLoading: false,
      fullPage: true,
      isAgree : null,
      shown : false
    };
  },
  methods: {
    ...mapActions(["authRequest","saveOneSignalUserId"]),
    switchVisability() {
      this.passwordField = document.querySelector("#password");
      var passStatus = document.getElementById("pass-status");
      if (this.passwordField.getAttribute("type") === "password") {
        this.passwordField.setAttribute("type", "text");
        passStatus.className = "fa fa-eye-slash";
      } else {
        this.passwordField.setAttribute("type", "password");
        passStatus.className = "fa fa-eye";
      }
    },
    async register() {
      const isEmailValid = await this.$refs.emailValidator.validate();
      const isphoneValid = await this.$refs.phoneValidator.validate();
      const ispasswordValid = await this.$refs.passwordValidator.validate();
      const ispasswordConfirmationValid = await this.$refs.passwordConfirmationValidator.validate();

      if (
        !isEmailValid.valid ||
        !isphoneValid.valid ||
        !ispasswordValid.valid ||
        !ispasswordConfirmationValid.valid
      )
        return;

      this.isLoading = true;
      this.registerRequest(this.postBody)
        .then((response) => {
          this.isLoading = false;
          if (
            response &&
            response.data &&
            response.data.error &&
            response.data.error.message &&
            response.data.error.message === this.$t('message.email_already_exist')
          ){
            helpers.showErrorMessageAlert(response.data.error.message);
          }else{
            helpers.showErrorMessageAlert(this.$t('message.thank_you_fo_signing_up'),
            null,"red", this.$t('button.ok')).then(()=>{
              this.login()
            });
          }
        })
        .catch((e) => {
          this.captureException(e)
          this.isLoading = false;
          helpers.showErrorMessageAlert(this.$t('generic_error.error_register'));
          
        });
    },
    backToLogin() {
      router.push("/login");
    },
    openModal(){
      this.shown = true;
    },
    login() {
      this.isLoading = true;
      this.authRequest({
        email: this.postBody.email,
        password: this.postBody.password
      })
        .then(response => {
          if (response && response.error) {
            this.isLoading = false;
            this.$router.push('/login');
          } 

          this.sendMessage({userId:response.data.id})
          this.saveOneSignalUserId(response.data.id)

          this.isLoading = false;
          this.$router.push('/');
        })
        .catch((e) => {
          this.captureException(e)
          this.isLoading = false;
          this.$router.push('/login');
        });
    }
  },
  mounted() {
    this.postBody.token = this.$route.query.token;
  },
  onCancel() {
    this.isLoading = false;
  },
};
</script>
<style scoped>
.register-page .alert {
  margin-top: 62px;
}
.form-group.input-group {
  padding: 0;
}

p.subscribe-newsletter{
  color: #FFF;
}

</style>
